import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChatWithPdf = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <rect width={24} height={24} fill="#35C2FF" rx={5} />
    <path
      stroke="#fff"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.049 11.486a5.337 5.337 0 0 1 5.278-6.153 5.337 5.337 0 0 1 4.995 7.223c-.046.122-.07.183-.08.23a.6.6 0 0 0-.016.13c0 .048.006.102.019.21l.267 2.18c.029.236.043.354.004.44a.33.33 0 0 1-.17.167c-.087.037-.204.02-.437-.014l-2.113-.312a2 2 0 0 0-.216-.024.6.6 0 0 0-.132.014c-.05.01-.112.034-.238.082a5.34 5.34 0 0 1-2.7.28m-3.442 2.728c1.967 0 3.56-1.642 3.56-3.667s-1.594-3.667-3.56-3.667-3.56 1.642-3.56 3.667c0 .407.064.799.183 1.164.05.155.076.232.084.285.009.055.01.086.007.142a2 2 0 0 1-.043.235l-.405 1.84 1.986-.272c.108-.015.162-.022.21-.022a.6.6 0 0 1 .125.013c.046.01.115.034.253.082.364.13.754.2 1.16.2"
    />
  </svg>
);
export default SvgChatWithPdf;
